var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDashCards = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44.54,
    height: 35.232,
    viewBox: "0 0 44.54 35.232",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236",
    transform: "translate(-904.496 -292.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(155 -18.132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M98.921,222.78V211.011a.81.81,0,0,1,.81-.81h27.8",
    transform: "translate(660.204 114.534)",
    fill: "none",
    stroke: "#153968",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M98.921,222.78v7.107a.811.811,0,0,0,.81.811h32.791a.811.811,0,0,0,.81-.811V211.011a.81.81,0,0,0-.81-.81h-4.989",
    transform: "translate(660.204 114.534)",
    fill: "none",
    stroke: "#153968",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 34.411,
    height: 3.153,
    transform: "translate(759.125 331.024)",
    fill: "#153968"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 14.319,
    transform: "translate(762.011 338.293)",
    fill: "none",
    stroke: "#153968",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x2: 14.319,
    transform: "translate(762.011 341.541)",
    fill: "none",
    stroke: "#153968",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(750 311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M122.62,203.959l-.916-10.325a.811.811,0,0,0-.879-.736l-32.662,2.9a.812.812,0,0,0-.736.879l1.668,18.8a.811.811,0,0,0,.879.736l4.969-.44",
    transform: "translate(-87.424 -192.895)",
    fill: "none",
    stroke: "#153968",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 34.411,
    height: 3.153,
    transform: "translate(35.006 8.921) rotate(174.93)",
    fill: "#153968"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y1: 0.442,
    x2: 4.981,
    transform: "translate(3.047 14.896)",
    fill: "none",
    stroke: "#153968",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    y1: 0.393,
    x2: 4.429,
    transform: "translate(3.4 18.921)",
    fill: "none",
    stroke: "#153968",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashCards, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dash_cards.a93d9182.svg";
export { ForwardRef as ReactComponent };